var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _rect, _path5, _path6, _mask, _path7, _path8, _rect2, _path9, _rect3, _path10, _path11, _path12, _path13, _rect4, _path14, _path15, _path16, _path17, _rect5, _path18, _path19, _path20, _path21, _path22, _g7, _circle, _g8, _circle2, _g9, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path23, _path24, _ellipse, _ellipse2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardApplied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 179,
    viewBox: "0 0 232 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19109_24816)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.387 8.34466L100.369 7.97894L100.311 7.59092L100.24 7.28764L100.164 7.06464L100.048 6.77474L99.9144 6.52052L99.6959 6.18156L99.4506 5.86936L99.2053 5.6196L98.9734 5.4189L98.7415 5.24942L98.4828 5.08886L98.2107 4.9506L97.9743 4.85248L97.7513 4.77666L97.4035 4.68746L97.1492 4.64732L96.9218 4.62502L96.6631 4.6161L96.4847 4.62056L96.2216 4.64286L95.9763 4.67854L95.7399 4.73206L95.5481 4.78558L95.4009 4.8391L95.2404 4.89708L95.0843 4.96844L94.9371 5.0398L94.8033 5.11116L94.616 5.23158L94.4286 5.36092L94.3171 5.45012L94.2324 5.51702L94.1254 5.61514L93.996 5.40552L93.7998 5.11562L93.6392 4.906L93.3895 4.6161L93.1352 4.36188L92.8989 4.14334L92.7026 3.9917L92.5019 3.84452L92.27 3.68842L91.9756 3.51448L91.7526 3.39852L91.4494 3.26472L91.1372 3.1443L90.7848 3.03726L90.4325 2.95698L90.1114 2.90346L89.8616 2.8767L89.5583 2.8544L89.3576 2.84994L88.9963 2.86332L88.7332 2.88562L88.4834 2.9213L88.2069 2.97036L87.8546 3.05956L87.6048 3.13538L87.306 3.24688L87.0562 3.35392L86.8377 3.46096L86.6459 3.56354L86.4229 3.69734L86.2356 3.82668L86.0572 3.95156L85.9457 4.04076L85.8743 4.09874L85.7851 4.1701L85.6915 4.25038L85.5844 4.06306L85.3124 3.63936L85.0359 3.26026L84.7772 2.93914L84.5319 2.66708L84.2598 2.3861L83.9922 2.13634L83.6488 1.84198L83.4436 1.68142L83.185 1.4941L82.953 1.338L82.7256 1.19528L82.507 1.06594L82.293 0.949981L81.9495 0.7805L81.6909 0.66454L81.4545 0.57088L81.1869 0.4683L80.839 0.3568L80.558 0.27652L80.2726 0.20516L79.9961 0.14718L79.6972 0.0981201L79.4118 0.05798L79.162 0.03122L78.8811 0.01338L78.6714 0H78.4172L78.1229 0.00446L77.8597 0.01784L77.5877 0.04014L77.3201 0.07136L77.0525 0.1115L76.7759 0.16056L76.5262 0.21408L76.272 0.27652L76.0044 0.35234L75.7457 0.43708L75.5316 0.5129L75.1882 0.6467L74.9117 0.771581L74.6842 0.878621L74.4746 0.990121L74.1713 1.1596L73.9884 1.2711L73.7476 1.4272L73.5469 1.56992L73.3239 1.73494L73.0875 1.92226L72.8734 2.10958L72.6237 2.3415L72.423 2.5422L72.2134 2.7652L71.9591 3.05956L71.7451 3.33608L71.5711 3.57692L71.3883 3.84452L71.2634 4.05414L71.0894 4.35742L70.9378 4.6384L70.804 4.92384L70.6791 5.2182L70.5765 5.49472L70.474 5.78908L70.3981 6.03884L70.3134 6.35996L70.2643 6.56958L70.2242 6.76136L70.1885 6.96652L70.1573 7.1583L70.135 7.35454L70.1038 7.65782L70.0859 7.92543V8.34466H71.0092H100.387Z",
    fill: "#080333"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M210.845 141.137C205.06 132.588 198.337 122.435 200.257 111.522C203.511 100.405 211.439 91.078 217.28 81.3333C224.178 69.0666 218.921 64.987 207.535 60.4901C203.622 59.0623 198.458 58.2742 194.638 56.6238C186.293 51.923 187.016 43.9399 175.111 38.6642C167.592 34.4641 160.48 35.7436 152.683 38.1543C146.211 39.8046 139.137 40.6113 132.47 40.4073C113.324 39.2483 93.89 38.2006 74.7066 38.4788C65.7314 38.7291 55.8476 38.8218 47.197 41.4643C35.2734 46.6936 25.7419 57.4026 24.6942 70.9951C23.7021 104.207 42.5147 110.669 38.1662 122.871C34.578 134.878 31.3051 158.41 43.2565 166.3C53.4184 170.797 74.9755 160.978 87.6223 161.025C99.9631 160.311 103.718 163.185 114.019 168.581C125.581 173.839 138.2 177 150.791 178.187C169.057 180.097 187.823 177.39 205.022 170.899C223.214 163.51 222.491 155.434 210.845 141.127V141.137Z",
    fill: "#080333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0921 147.989H178.841C184.756 147.989 190.7 148.174 196.615 147.989C196.699 147.989 196.782 147.989 196.865 147.989C198.655 147.989 198.655 145.207 196.865 145.207H68.1166C62.2011 145.207 56.2579 145.022 50.3424 145.207C50.259 145.207 50.1755 145.207 50.0921 145.207C48.3026 145.207 48.3026 147.989 50.0921 147.989Z",
    fill: "#080333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.287 147.985H216.137C217.926 147.985 217.926 145.203 216.137 145.203H204.287C202.498 145.203 202.498 147.985 204.287 147.985Z",
    fill: "#080333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8109 147.985H42.6603C44.4497 147.985 44.4497 145.203 42.6603 145.203H30.8109C29.0214 145.203 29.0214 147.985 30.8109 147.985Z",
    fill: "#080333"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19109_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M224.09 33.375L223.163 39.8376L217.508 40.995L223.504 42.2875L225.017 48.21L225.963 41.9982L231.354 40.7828L225.812 39.8954L224.09 33.375Z",
    fill: "#7292FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_19109_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M223.161 110.336L222.234 116.799L216.578 117.956L222.574 119.248L224.087 125.171L225.033 118.959L230.424 117.744L224.882 116.856L223.161 110.336Z",
    fill: "#7292FE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_19109_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.22313 49.1406L6.29628 55.6032L0.640625 56.7607L6.63676 58.0532L8.14998 63.9756L9.09574 57.7638L14.4866 56.5485L8.94442 55.6611L7.22313 49.1406Z",
    fill: "#7292FE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_19109_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.22313 127.953L6.29628 134.416L0.640625 135.573L6.63676 136.866L8.14998 142.788L9.09574 136.576L14.4866 135.361L8.94442 134.474L7.22313 127.953Z",
    fill: "#7292FE"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_19109_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M17.8381 87.1562L17.3747 90.3875L14.5469 90.9663L17.5449 91.6125L18.3016 94.5737L18.7744 91.4678L21.4699 90.8602L18.6988 90.4165L17.8381 87.1562Z",
    fill: "#7292FE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 42,
    width: 79,
    height: 104,
    rx: 4,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M164 42H84V51H164V42Z",
    fill: "#080333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M163 137H85V146H163V137Z",
    fill: "#080333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-1_19109_24816",
    maskUnits: "userSpaceOnUse",
    x: 102.641,
    y: 33,
    width: 42,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 102.641,
    y: 33,
    width: 42,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.641 40C105.641 37.7909 107.431 36 109.641 36H137.641C139.85 36 141.641 37.7909 141.641 40V44C141.641 46.2091 139.85 48 137.641 48H109.641C107.431 48 105.641 46.2091 105.641 44V40Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.641 40C105.641 37.7909 107.431 36 109.641 36H137.641C139.85 36 141.641 37.7909 141.641 40V44C141.641 46.2091 139.85 48 137.641 48H109.641C107.431 48 105.641 46.2091 105.641 44V40Z",
    fill: "#90079E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.641 39H137.641V33H109.641V39ZM138.641 40V44H144.641V40H138.641ZM137.641 45H109.641V51H137.641V45ZM108.641 44V40H102.641V44H108.641ZM109.641 45C109.088 45 108.641 44.5523 108.641 44H102.641C102.641 47.866 105.775 51 109.641 51V45ZM138.641 44C138.641 44.5523 138.193 45 137.641 45V51C141.507 51 144.641 47.866 144.641 44H138.641ZM137.641 39C138.193 39 138.641 39.4477 138.641 40H144.641C144.641 36.134 141.507 33 137.641 33V39ZM109.641 33C105.775 33 102.641 36.134 102.641 40H108.641C108.641 39.4477 109.088 39 109.641 39V33Z",
    fill: "#080333",
    mask: "url(#path-14-outside-1_19109_24816)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109.641,
    y: 39,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E7F0FE",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M136.766 40H110.516V42H136.766V40Z",
    fill: "#080333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.6406,
    y: 57,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6406 63.8L96.7406 65.9L100.641 62",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 58L150.641 58",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 64L131.641 64",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 70H131.641",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.6406,
    y: 87,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6406 93.8L96.7406 95.9L100.641 92",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 88L150.641 88",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 94H131.641",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.641 100H131.641",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.6406,
    y: 118,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6406 124.8L98.7406 126.9L102.641 123",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.641 119L152.641 119",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.641 125H133.641",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.641 131H133.641",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.111 121.939C164.83 122.221 164.672 122.602 164.672 123C164.672 123.398 164.83 123.779 165.111 124.061L175.939 134.889C176.525 135.474 177.475 135.474 178.061 134.889L196.889 116.061C197.474 115.475 197.474 114.525 196.889 113.939L194.061 111.111C193.779 110.83 193.398 110.672 193 110.672C192.602 110.672 192.221 110.83 191.939 111.111L177 126.051L170.061 119.111C169.475 118.526 168.525 118.526 167.939 119.111L165.111 121.939ZM168.5 104.292C172.199 101.82 176.549 100.5 180.998 100.5C186.96 100.518 192.673 102.894 196.89 107.11C201.106 111.327 203.482 117.039 203.5 123.002C203.5 127.451 202.18 131.801 199.708 135.5C197.236 139.2 193.722 142.084 189.61 143.787C185.499 145.49 180.975 145.936 176.61 145.068C172.246 144.2 168.237 142.057 165.09 138.91C161.943 135.763 159.801 131.754 158.932 127.39C158.064 123.025 158.51 118.501 160.213 114.39C161.916 110.278 164.8 106.764 168.5 104.292Z",
    fill: "#795AF7",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181 105.881C169.927 105.881 160.881 112.979 160.059 122C160.029 121.469 160 120.961 160 120.408C160 109.132 169.399 100 181 100C192.601 100 202 109.154 202 120.408C202 120.939 202 121.469 201.941 122C201.119 112.979 192.043 105.881 181 105.881Z",
    fill: "#000917"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 120,
    r: 26,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.998 98.9648C77.532 98.9648 87.772 104.956 88.7029 112.571C88.7362 112.123 88.7694 111.694 88.7694 111.228C88.7694 101.709 78.1305 94 64.998 94C51.8655 94 41.2266 101.727 41.2266 111.228C41.2266 111.676 41.2266 112.123 41.2931 112.571C42.224 104.956 52.4972 98.9648 64.998 98.9648Z",
    fill: "#080333"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0025,
    cy: 120.002,
    r: 20.0571,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0018 104.91C75.1857 104.91 83.5057 110.902 84.262 118.517C84.289 118.069 84.3161 117.639 84.3161 117.173C84.3161 107.654 75.6719 99.9453 65.0018 99.9453C54.3317 99.9453 45.6875 107.673 45.6875 117.173C45.6875 117.621 45.6875 118.069 45.7415 118.517C46.4979 110.902 54.8449 104.91 65.0018 104.91Z",
    fill: "#080333"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0013,
    cy: 103.658,
    r: 1.48571,
    fill: "#080333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0013,
    cy: 137.087,
    r: 1.48571,
    fill: "#080333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.7174,
    cy: 120.369,
    r: 1.48571,
    transform: "rotate(90 81.7174 120.369)",
    fill: "#080333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2877,
    cy: 120.369,
    r: 1.48571,
    transform: "rotate(90 48.2877 120.369)",
    fill: "#080333"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8208,
    cy: 132.188,
    r: 1.48571,
    transform: "rotate(135 76.8208 132.188)",
    fill: "#080333"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1801,
    cy: 108.555,
    r: 1.48571,
    transform: "rotate(135 53.1801 108.555)",
    fill: "#080333"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1797,
    cy: 132.188,
    r: 1.48571,
    transform: "rotate(-135 53.1797 132.188)",
    fill: "#080333"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8203,
    cy: 108.555,
    r: 1.48571,
    transform: "rotate(-135 76.8203 108.555)",
    fill: "#080333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65 120.746L65 108.117",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0011 120.741L72.4297 113.312",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.0051,
    cy: 120.003,
    rx: 2.97143,
    ry: 2.97143,
    transform: "rotate(90 65.0051 120.003)",
    fill: "#080333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 120,
    rx: 1.27347,
    ry: 1.27347,
    transform: "rotate(90 65 120)",
    fill: "#795AF7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3013,
    height: 8.34466,
    fill: "white",
    transform: "translate(70.0859)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(217.508 33.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(216.578 110.336)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(0.640625 49.1406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(0.640625 127.953)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_19109_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.92298,
    height: 7.41748,
    fill: "white",
    transform: "translate(14.5469 87.1562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardApplied);
export default __webpack_public_path__ + "static/media/card-applied.bd1214c330a94e872dac21969f90b69f.svg";
export { ForwardRef as ReactComponent };